import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import GlassCard from '@/components/shared/GlassCard';

const FAQItem = ({ question, answer, animationDelayValue }) => (
  <GlassCard
    className="faq-item animate__animated animate__fadeInUp"
    style={{ animationDelay: `${animationDelayValue}s` }}
  >
    <div className="question">
      <FontAwesomeIcon icon={faQuestionCircle} />
      {question}
    </div>
    <div className="answer">
      <FontAwesomeIcon icon={faArrowRight} />
      {answer}
    </div>
  </GlassCard>
);

export default FAQItem;
